import React from 'react';

const PageHeader = () => {
  return (
    <section
      className="relative min-h-[60vh] pt-28 pb-20 md:pt-32 md:pb-20 flex items-center justify-center"
      style={{
        backgroundImage: `url('/storage/gallery_images/slider-3.png')`, // consistent image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Navy overlay */}
      <div className="absolute inset-0 bg-blue-900/70"></div>

      {/* Content */}
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center justify-center">
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow">
          Frequently Asked Questions
        </h1>
        <p className="text-xl md:text-2xl text-white/90 max-w-4xl mx-auto mb-8 leading-relaxed drop-shadow">
          Get quick answers to common questions about our eye care services,
          appointments, and treatments.
        </p>
      </div>
    </section>
  );
};

export default PageHeader;
